import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useParams } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthProvider';
import DevAuthProvider from './contexts/DevAuthProvider';
import PrivateRoute from './components/PrivateRoute';
import Toaster from './components/Toaster';
import Login from './pages/Login';
import SSOCallback from './pages/SSOCallback';
import Dashboard from './pages/Dashboard';
import Sources from './pages/Sources';
import Feeds from './pages/Feeds';
import FeedEditor from './pages/FeedEditor';
import Channels from './pages/Channels';
import MasterRules from './pages/MasterRules';
import Categorisation from './pages/Categorisation';
import Schedule from './pages/Schedule';
import config from './config';

const Provider = config.devAuth ? DevAuthProvider : AuthProvider;
const private_ = (el) => <PrivateRoute>{el}</PrivateRoute>;

// Remount the editor per feed: /feeds/1 → /feeds/2 (e.g. via ⌘K) must not keep
// feed 1's preview / excluded / quality state or let its late responses land.
function FeedEditorRoute() {
  const { id } = useParams();
  return <FeedEditor key={id} />;
}

function App() {
  // Apply saved theme on app load (before any page renders)
  useEffect(() => {
    const stored = localStorage.getItem('theme');
    const prefersDark = window.matchMedia?.('(prefers-color-scheme: dark)').matches;
    if (stored === 'dark' || (!stored && prefersDark)) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, []);

  return (
    <Provider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/sso-callback" element={<SSOCallback />} />
          <Route path="/dashboard" element={private_(<Dashboard />)} />
          <Route path="/sources" element={private_(<Sources />)} />
          <Route path="/master-rules" element={private_(<MasterRules />)} />
          <Route path="/categorisation" element={private_(<Categorisation />)} />
          <Route path="/feeds" element={private_(<Feeds />)} />
          <Route path="/feeds/:id" element={private_(<FeedEditorRoute />)} />
          <Route path="/channels" element={private_(<Channels />)} />
          <Route path="/schedule" element={private_(<Schedule />)} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
        </Routes>
        <Toaster />
      </Router>
    </Provider>
  );
}

export default App;
